import { useTranslation } from "@coworker/locales";
import { memo, useCallback, useState } from "react";
import ErrorAddOn from "../TaskCreatorAndEditorSheet/ListItem/ErrorAddOn/ErrorAddOn";
import { ItemNoAndType } from "@coworker/apprestructured/src/shared/types/item";
import { GroupedSalesLocations } from "@coworker/apprestructured/src/task-management/types/SalesLocation";
import { LocationChange } from "@coworker/apprestructured/src/task-management/types/SalesLocation";
import ListItem from "../TaskCreatorAndEditorSheet/ListItem/ListItem";
import {
  AddLocationModal,
  AddLocationTab,
  getDefaultLocationTab,
} from "./AddLocationModal";
interface AddLocationProps {
  onTabChanged: (tabId: AddLocationTab) => void;
  itemNoAndType: ItemNoAndType | null;
  slid: string;
  customLocation: string;
  disabled: boolean;
  onConfirmClick: ({ slid, customLocation }: LocationChange) => void;
  isLoadingLocations: boolean;
  filteredLocations: GroupedSalesLocations;
  totalAssignedSalesSpaceQuantity: number;
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  isError?: boolean;
  showNamingConvention?: boolean;
}

export { getDefaultLocationTab };
export type { AddLocationTab };

export const AddLocation = memo(
  ({
    onTabChanged,
    itemNoAndType,
    slid,
    customLocation,
    disabled,
    onConfirmClick,
    isLoadingLocations,
    filteredLocations,
    totalAssignedSalesSpaceQuantity,
    searchQuery,
    setSearchQuery,
    isError = false,
  }: AddLocationProps) => {
    const [showModal, setShowModal] = useState(false);

    const handleOpenModal = useCallback(() => {
      setShowModal(true);
    }, []);

    const handleCloseModal = useCallback(() => {
      setShowModal(false);
    }, []);

    const { t } = useTranslation();

    const description = slid || customLocation;
    const emphasised = !!slid || !!customLocation;

    return (
      <>
        <ListItem
          testId="add-location-list-item"
          title={t("location3String")}
          onClick={handleOpenModal}
          emphasised={emphasised}
          description={description}
          disabled={disabled}
          addOn={
            isError ? (
              <ErrorAddOn testId="add-location-error">
                {t("pleaseFillInString")}
              </ErrorAddOn>
            ) : null
          }
        />
        <AddLocationModal
          visible={showModal}
          onClose={handleCloseModal}
          onTabChanged={onTabChanged}
          itemNoAndType={itemNoAndType}
          slid={slid}
          customLocation={customLocation}
          onConfirmClick={onConfirmClick}
          isLoadingLocations={isLoadingLocations}
          filteredLocations={filteredLocations}
          totalAssignedSalesSpaceQuantity={totalAssignedSalesSpaceQuantity}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
        />
      </>
    );
  }
);
